import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import useAct from 'Workflows/hooks/useAct'
import BaseNode from './BaseNode'

function ExitNode({ id, data }) {
  const act = useAct()

  function onClick() {
    act.local.setSidebar({ kind: 'editNode', nodeId: parseInt(id) });
  }

  return <BaseNode id={id} kind={'exit'} onClick={onClick}>
    <Handle type="target" position={Position.Top} />
  </BaseNode>
}

export default memo(ExitNode);
